// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"6e4fd1a3","528":"3bfee667","633":"fd33de0c"}[chunkId] + ".chunk.js";
};